import React, { Component } from 'react'
import s from './styles.scss'
import { Query } from "react-apollo";
import gql from "graphql-tag";
// import { Link } from 'react-router-dom'
import urls from '../../../../configs/urls'

const QUERY = gql`
query User($uuid: String) {
  user(_id: $uuid) {
    id
    _id
    first_name
    last_name
    email
    phone_number
    unique_id
    role
    files {
      name
      url
      minetype
    }
    tutors {
      id
      _id
      tutor_validations {
        proofs
        proofs_state
        proofs_reasons
        profile_picture
        profile_picture_state
        profile_picture_reasons
        location
        location_state
        location_reasons
        
      }
      tutor_subject_levels {
        level {
          name
        }
        subject {
          name
        }
        valid
        validation_state
        justification
        has_report_card
      } 
      photo
      biography
      experience
      schools {
        name
        level
      }
    }
  }
}
`

class UsersDetails extends Component {

  render() {

    if (!this.props.uuid) return null

    return <Query
      query={QUERY}
      variables={{
        uuid: this.props.uuid
      }}
      >
      {({ loading, error, data, fetchMore }) => {
      if (loading) return <p>Loading...</p>;
      if (error) {
        console.error(error)
        return <p>Error :(</p>
      };

      if (!data.user) return null

      console.log('NEW USER', data, this.props.uuid)
      const { id, _id, first_name, last_name, email, phone_number, role, tutors, files, unique_id } = data.user

      return <div className={s.container}>
        <h2>Details</h2>

        <div className="box">
          <b>{first_name} {last_name}</b> <br />
          <i>{unique_id}</i> <br />
            <small>{email}</small> <br />
            <small>{phone_number}</small> <br />
            <small>{role}</small> <br /><br />
            <small>ID: {id}</small> <br />
            <small>UUID: {_id}</small> <br />
        </div>

        <div className="box">
          <form method="post" action={`${urls.api}auth/loginas`}>
            <input type="hidden" name="uuid" value={_id} />
            <button type="submit">View user profile</button>
          </form>
        </div>

        {tutors.length && tutors[0] && <React.Fragment>
          <div className="box">
            <h4>Tutor</h4>
            <p>{tutors[0].biography}</p>
            <p>{tutors[0].experience}</p>

            <small>ID: {tutors[0].id}</small> <br/>
            <small>UUID: {tutors[0]._id}</small>

            <br/>
            <br/>
            <img src={tutors[0].photo} className={s.image} />

            <br/>
            <br/>
            

            <h4>Matières</h4>
            {tutors[0].tutor_subject_levels && tutors[0].tutor_subject_levels.map(({level, subject, valid, validation_state, justification}, key) => {
              return <div key={key}>
                <b>{subject.name} - {level.name}</b> <br />
                <small>{valid ? "Validated" : "To validate"}</small> <br />
                <small>{validation_state}</small> <br />
                <small>{justification}</small>
              </div>
            })}

            <h4>Files</h4>
            {files.map(({ name, url, minetype }, key) => <div>
              <b>{name} - {minetype}</b> <br />
              <small><a href={url} target="_blank">{url}</a></small>
            </div>)}
          </div>
        </React.Fragment>}

      </div>

      }}
  </Query>
  }
}

export default UsersDetails;



// WEBPACK FOOTER //
// ./src/containers/users/Details/tabs/general.js